export const routeMatch = {
    worker: {
        text: '라이더',
        href: '/worker',
        disabled: false,
    },
    adjustment: {
        text: '정산',
        href: '/worker/adjustment/withholdTaxReport',
        disabled: false,
    },
    withholdTaxReport: {
        text: '이행상황 신고',
        href: '/worker/adjustment/withholdTaxReport',
        disabled: false,
    },
    simplePaymentDetail: {
        text: '간이 지급명세',
        href: '/worker/adjustment/simplePaymentDetail',
        disabled: false,
    },
    detailsPerWorker: {
        text: '라이더별 상세조회',
        href: '/worker/adjustment/detailsPerWorker',
        disabled: false,
    },
    paymentDetail: {
        text: '지급명세(년)',
        href: '/worker/adjustment/paymentDetail',
        disabled: false,
    },
};
export const detailsPerWorkerTableHeader = [
    {
        title: '라이더명',
        // value: 'name',
        sortable: false,
        // width: 220
    },
    {
        title: '실명',
        // value: 'realName', api 프로퍼티 미정
        sortable: false,
        // width: 220
    },
    {
        title: '라이더번호',
        // value: 'telNumber',
        sortable: false,
        // width: 220
    },
    {
        title: '소속',
        // value: 'storeName',
        sortable: false,
        // width: 220
    },
    {
        title: '이메일',
        // value: 'email',
        sortable: false,
        // width: 220
    },
    {
        title: '보수지급방식',
        // value: 'storeName',
        sortable: false,
        // width: 220
    },
    {
        title: '완료 건 수',
        // value: 'storeName',
        sortable: true,
        // width: 220
    },
    {
        title: '지급총액',
        // value: 'storeName',
        sortable: true,
        // width: 220
    },
];
export const simplePaymentDetailTableHeader = [
    {
        title: '귀속년월',
        // value: '',
        sortable: false,
        width: 70,
    },
    {
        title: '지급년월일',
        // value: '',
        sortable: false,
        width: 220,
    },
    {
        title: '소득자명',
        // value: '',
        sortable: false,
        width: 70,
    },
    {
        title: '주민등록번호',
        // value: '',
        sortable: false,
        width: 140,
    },
    {
        title: '소득구분',
        // value: '',
        sortable: false,
        width: 140,
    },
    {
        title: '지급총액',
        // value: '',
        sortable: false,
        width: 140,
        align: 'end',
    },
    {
        title: '세율',
        // value: '',
        sortable: false,
        width: 140,
        align: 'end',
    },
    {
        title: '소득세',
        // value: '',
        sortable: false,
        width: 140,
        align: 'end',
    },
    {
        title: '지방소득세',
        // value: '',
        sortable: false,
        width: 140,
        align: 'end',
    },
];
export const paymentDetailTableHeader = [
    {
        title: '종목코드',
        // value: '',
        sortable: false,
        width: 70,
    },
    {
        title: '소득자명',
        // value: '',
        sortable: false,
        width: 70,
    },
    {
        title: '주민등록번호',
        // value: '',
        sortable: false,
        width: 140,
    },
    {
        title: '귀속년도',
        // value: '',
        sortable: false,
        width: 140,
    },
    {
        title: '지급년도',
        // value: '',
        sortable: false,
        width: 140,
    },
    {
        title: '지급건수',
        // value: '',
        sortable: false,
        width: 140,
        align: 'end',
    },
    {
        title: '연간지급총액',
        // value: '',
        sortable: false,
        width: 140,
        align: 'end',
    },
    {
        title: '세율',
        // value: '',
        sortable: false,
        width: 140,
        align: 'end',
    },
    {
        title: '소득세',
        // value: '',
        sortable: false,
        width: 140,
        align: 'end',
    },
    {
        title: '지방소득세',
        // value: '',
        sortable: false,
        width: 140,
        align: 'end',
    },
    {
        title: '세엑계',
        // value: '',
        sortable: false,
        width: 140,
        align: 'end',
    },
];
// 라이더별 상세조회 > 지급내역
export const workerPaymentStatementHeader = [
    {
        title: 'a',
        value: 'a',
        sortable: false,
    },
    {
        title: 'b',
        value: 'b',
        width: 130,
        sortable: false,
    },
    {
        title: 'c',
        value: 'c',
        width: 130,
        sortable: false,
    },
];
// 라이더별 상세조회 > 지급내역
export const workerDeductionStatementHeader = [
    {
        title: 'a',
        value: 'a',
        sortable: false,
    },
    {
        title: 'b',
        value: 'b',
        width: 130,
        sortable: false,
    },
    {
        title: 'c',
        value: 'c',
        width: 130,
        sortable: false,
    },
];
// 검색란 검색유형
export const searchFieldTypeOptions = [
    {
        text: '라이더',
        value: 'ALLOCATED_WORKER_NAME',
        field: 'allocatedWorkerName',
    },
];
